import { app } from '../../../core/App';
import { Sounds } from '../../../sounds';
import { Vehicle } from '../../vehicle/Vehicle';
import { BodyTypes } from '../../LevelManager';
import { RunSettingsHandler } from '../../RunSettingsHandler';
import { Station } from '../Station';
import { LaneEntitySpine } from './LaneEntitySpine';
import { ChargeEffect } from './../ChargeEffect';

export const ChargeStripSkins = {
  Normal: 'charge-strip',
  Scrap: 'scrap-charge-strip',
  Dock: 'dock-charge-strip',
  Sky: 'sky-charge-strip',
  Ice: 'ice-charge-strip',
} as const;
export type ChargeStripSkinsKeys = keyof typeof ChargeStripSkins;
export type ChargeStripSkinsValues = typeof ChargeStripSkins[ChargeStripSkinsKeys];

export class ChargeStrip extends LaneEntitySpine {
  public static animations = {
    Idle: 'idle',
    Charge: 'charge-strip-flash'
  } as const;

  protected hasCharge: boolean;
  protected station: Station | undefined;

  constructor(scene: Phaser.Scene, x: number, y: number, skin: ChargeStripSkinsValues) {
    super(scene, x, y, skin, ChargeStrip.animations.Idle, true);

    this.hasCharge = true;
    this.spawnOffsetY = -8;
    if (skin == ChargeStripSkins.Sky) this.spawnOffsetY = 0;
    else if (skin == ChargeStripSkins.Scrap) this.spawnOffsetY = 0;
    else if (skin == ChargeStripSkins.Dock) this.spawnOffsetY = -54;

    this.y += this.spawnOffsetY;

    this.injectMatter(this as unknown as Phaser.GameObjects.GameObject);

    this.addToUpdateList();
  }

  public init() {}

  public setStation(station: Station) {
    this.station = station;
    this.hasCharge = true;
  }

  public pickupCharge() {
    this.hasCharge = false;

    RunSettingsHandler.collectCharge(this.scene, this.station?.ChargeAmount ?? 1);
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    let x = this.x;
    let y = this.y;

    this.scene.matter.add.gameObject(target, {
      label: BodyTypes.ChargingStation,
      isStatic: true,
      isSensor: true,
      onCollideCallback: this.onCollisionStart.bind(this)
    }) as Phaser.Physics.Matter.Sprite;

    this.scene.matter.body.setPosition(target.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(target.body as MatterJS.BodyType, 0, 0);
  }

  protected onCollisionStart(pair: MatterJS.ICollisionPair) {
    if (!this.hasCharge || !this.station) return;

    if ((pair.bodyA as MatterJS.BodyType).label == BodyTypes.Vehicle && (pair.bodyB as MatterJS.BodyType).label == BodyTypes.ChargingStation) {
      this.onVehicleCollisionStart(pair, pair.bodyA as MatterJS.BodyType, pair.bodyB as MatterJS.BodyType);
    } else if ((pair.bodyB as MatterJS.BodyType).label == BodyTypes.Vehicle && (pair.bodyA as MatterJS.BodyType).label == BodyTypes.ChargingStation) {
      this.onVehicleCollisionStart(pair, pair.bodyB as MatterJS.BodyType, pair.bodyA as MatterJS.BodyType);
    }
  }

  protected onVehicleCollisionStart(pair: MatterJS.ICollisionPair, vehicle: MatterJS.BodyType, taxiRank: MatterJS.BodyType) {
    if (vehicle.gameObject instanceof Vehicle && vehicle.gameObject.IsPlayer && this.hasCharge && this.station) {
      this.station.pickedUp();
      this.pickupCharge();
      vehicle.gameObject.CharacterSpine.heroCharge();
      this.station = undefined;
      this.setAnimation(0, ChargeStrip.animations.Charge, false);

      let effect = new ChargeEffect(this.scene, vehicle.gameObject.x, vehicle.gameObject.y);
      effect.fire();

      app.audioHandler.playSound(this.scene, Sounds.Track.Charge1, Sounds.Channel.SFX);
      app.audioHandler.playSound(this.scene, vehicle.gameObject.sounds.boost, Sounds.Channel.SFX);
    }
  }
}
